import React from "react";
import { Tabs } from "antd";
import { TitleWrap, TabsWrapper } from "./styles";
import Form from "../Form";
import { connect } from "react-redux";
import { addSuccessorCount, addSuccessor, resetLegacy, jsonTemp,setSuccessorTab } from "../../../actions";

const TabPane = Tabs.TabPane;
export class TabsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.newTabIndex = 1;
    this.successorKey = "";
    const panes = [
      {
        key: "1"
      }
    ];

    this.state = {
      activeKey: panes[0].key,
      panes
    };
  }

  componentWillReceiveProps(props) {
    if(props.isReset) {
      this.setState({
        activeKey: "1",
        panes: [{ key: 1}]
      })
      this.props.resetLegacy({
        resetLegacy: false
    });
    }   
  }

  handleAddSuccessor = e => {
    let id = document.getElementById(e);
    id.scrollIntoView(0);
    const panes = this.state.panes;
    this.newTabIndex = this.props.legacy.length + 1;
    const activeKey = (this.newTabIndex).toString();
    panes.push({
      key: activeKey
    });
    
    let countArr = [this.props.count];
    countArr.push(this.props.count + 1);
    let arr;

    if(this.props.isStep2Edit) {
      arr = this.props.tempData.tempJSON.legacyOptions
    } else {
      arr = this.props.legacyArr.legacyOptions;
    }

    arr.filter(val => {
      if (val.optionId == this.props.contentKey) {
        if(e == 4) {
          let data;
          if(this.props.isStep2Edit) {
            data = val.successionPlanGranteeOrg;
          } else {
            data = val.successorAdvisor.successorAdvisor
          }
          data.push({
            key: (data.length + 1).toString(),
            name: "",
            contactFirstName: "",
            contactLastName: "",
            contactPhone: "",
            contactEmail: "",
            charityAllocPercent: "",
            grantRecognition: "",
            grantPurpose: "",
            otherGrantPurposeText: "",
            ein: "",
            address: {
              line1: "",
              line2: "",
              line3: "",
              state: "",
              city: "",
              zip: "",
              country: '0'
            }
          });
        } else {
          let data;
          if(this.props.isStep2Edit) {
            data = val.successorAdvisor;
          } else {
            data = val.successorAdvisor.successorAdvisor
          }
          data.push({
            key: (data.length + 1).toString(),
            title: "",
            firstName: "",
            middleName: "",
            lastName: "",
            suffix: "",
            relationshipType: "",
            dob: "",
            gender: "",
            preferedPhone: "",
            preferedEmail: "",
            address: {
              line1: "",
              line2: "",
              line3: "",
              state: "",
              city: "",
              zip: "",
              country: "0"
            }
          });
        }
       
      }
    });
    this.setState({ panes, activeKey });
    if(this.props.isStep2Edit) {
      let tempData = this.props.tempData.tempJSON;
      tempData.legacyOptions = arr
      this.props.jsonTemp({
        tempJSON: tempData
      })
    } else {
      this.props.addSuccessor({
        legacyOptions: arr
      });
    }
    
    if(typeof(e) == "number") {
      if(e == 2) {
        if(this.props.createCount) {
          this.props.incrementCount({
            createCount: this.props.createCount + 1,
            count: this.props.count,
            charityCount: this.props.charityCount
          })
        } else {
          this.props.incrementCount({
            createCount: 2,
            count: this.props.count,
            charityCount: this.props.charityCount
          })
        }
      } else if(e == 4) {
        if(this.props.charityCount) {
          this.props.incrementCount({
            charityCount: this.props.charityCount + 1,
            count: this.props.count,
            createCount: this.props.createCount
          })
        } else {
          this.props.incrementCount({
            charityCount: 2,
            count: this.props.count,
            createCount: this.props.createCount
          })
        }
      } else {
        this.props.incrementCount({
          count: this.props.count + 1,
          createCount: this.props.createCount,
          charityCount: this.props.charityCount
        });
      }
      
    } else {
      this.props.incrementCount({
        count: this.props.count + 1,
        createCount: this.props.createCount,
        charityCount: this.props.charityCount
      });
    }
    
  };

  onChange = activeKey => {
    this.setState({ activeKey });
  };

  handleRemoveSuccessor = (targetKey, e) => {
    if(e) {
     let id = document.getElementById(e);
      id.scrollIntoView(0);
    }
    document.body.style.overflow = "";
    let arr;
    if(this.props.isStep2Edit) {
      arr = this.props.tempData.tempJSON.legacyOptions;
    } else {
      arr = this.props.legacyArr.legacyOptions;
    }
    let activeKey = this.state.activeKey;
    let lastIndex;
    
    this.state.panes.forEach((pane, i) => {
      if (pane.key == targetKey) {
        lastIndex = i - 1;
      }
    });

    const panes = this.state.panes.filter(pane => {
      return pane.key != targetKey});

    if (panes.length && activeKey == targetKey) {
      if (lastIndex >= 0) {
        activeKey = panes[lastIndex].key
      } else {
        activeKey = panes[0].key;
      }
    }
    if(targetKey == "1") {
      this.setState({ panes, activeKey: "1"})
    } else {
      if(activeKey == "1") {
        this.setState({ panes, activeKey });
      }
      else {
        this.setState({ panes, activeKey: (targetKey - 1).toString() });
      }
    }
    arr.forEach(val => {
      if (val.optionId == this.props.contentKey) {
        if(this.props.isStep2Edit) {
          if(this.props.contentKey == 1 || this.props.contentKey == 2) {
            val.successorAdvisor = val.successorAdvisor.filter(val2 => {
              return val2.key !== targetKey
            })
          } else {
            val.successionPlanGranteeOrg = val.successionPlanGranteeOrg.filter(val2 => {
              return val2.key !== targetKey
            })
          }
          
        } else {
          val.successorAdvisor.successorAdvisor = val.successorAdvisor.successorAdvisor.filter(val2 => {
            return val2.key !== targetKey
          })

          val.successorAdvisor.successorAdvisor.forEach((val,i) => {
            val.key = i+1;
          })

        }
      }
    })
    if(typeof(e) == "number") {
      if(e == 2) {
          this.props.incrementCount({
            createCount: this.props.createCount - 1,
            count: this.props.count,
            charityCount: this.props.charityCount
          }) 
        } else if( e == 4 ) {
          this.props.incrementCount({
            createCount: this.props.createCount,
            count: this.props.count,
            charityCount: this.props.charityCount - 1
          })
        } else {
          this.props.incrementCount({
            createCount: this.props.createCount,
            count: this.props.count - 1,
            charityCount: this.props.charityCount
          })
        }
      } else {
      this.props.incrementCount({
        count: this.props.count - 1,
        createCount: this.props.createCount,
        charityCount: this.props.charityCount
      });
    }
    if(this.props.isStep2Edit) {
      let tempData = this.props.tempData.tempJSON;
      tempData.legacyOptions = arr
      this.props.jsonTemp({
        tempJSON: tempData
      })
    } else {
      this.props.addSuccessor({
        legacyOptions: arr
      });
    }
    
  };

  getTitle(index){
    switch (this.props.contentKey) {
      case 1: return <TitleWrap>Successor {index + 1}</TitleWrap>
      case 2: return <TitleWrap>Successor account {index + 1}</TitleWrap>
      default: return <TitleWrap>Charity {index + 1}</TitleWrap>
    }
  }

  render() {
    let data;
    if(this.props.isStep2Edit) {
      if(this.props.contentKey == 1 || this.props.contentKey == 2 ) {
        data = this.props.tempData.tempJSON.legacyOptions[this.props.contentKey - 1].successorAdvisor
      } else {
        data = this.props.tempData.tempJSON.legacyOptions[this.props.contentKey - 1].successionPlanGranteeOrg
      }      
    } else {
      data = this.props.legacy
    }
    return (
      <TabsWrapper>
        <Tabs
          tabPosition="top"
          onChange={this.onChange}
          activeKey={this.state.activeKey}
          type="card"
        >
          {data.map((value, index) => {
            this.successorKey = value.key
            this.props.successorTab(value.key);
            return (
            <TabPane
              tab={this.getTitle(index)}
              key={value.key}
            >
                <Form
                handleChange={this.props.handleChange}
                head={this.props.head}
                add={this.handleAddSuccessor}
                remove={this.handleRemoveSuccessor}
                contentKey={this.props.contentKey}
                successorKey={value.key}
              />
            </TabPane>
          )})}

        </Tabs>
      </TabsWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  createCount: state.getIn(["npaFormReducer", "advisorCount", "createCount"]),
  count: state.getIn(["npaFormReducer", "advisorCount", "count"]),
  charityCount: state.getIn(["npaFormReducer", "advisorCount", "charityCount"]),
  legacy: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions",
    `${parseInt(ownProps.contentKey) - 1}`,
    "successorAdvisor",
    "successorAdvisor"
  ]),
  legacyArr: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions" ]),
  isReset: state.getIn(["npaFormReducer", "resetLegacy", "resetLegacy"]),
  isStep2Edit: state.getIn(["npaFormReducer", "isStep2Edit", "isStep2Edit", "isStep2Edit"]),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"])
});

const mapDispatchToProps = dispatch => ({
  incrementCount: count => dispatch(addSuccessorCount(count)),
  addSuccessor: count => dispatch(addSuccessor(count)),
  resetLegacy: val => dispatch(resetLegacy(val)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  successorTab: val => dispatch(setSuccessorTab(val))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabsComponent);
